import { apiClient } from '~/api/client';
import { AgentTransactionsMeta } from '~/sections/agents/profile/types';
import { LoanTransactionsMeta } from '~/sections/loan-officers/profile/financial-performance/types';

type IndexParams = {
  period: number;
  id: string;
};

type IndexResponse = {
  meta: {
    individual_chart_data: AgentTransactionsMeta;
    individual_total: number;
    individual_loan_data: LoanTransactionsMeta;
    team_chart_data: AgentTransactionsMeta;
    team_total: number;
    team_loan_data: LoanTransactionsMeta;
  };
};

export const index = async (allParams: IndexParams) => {
  const { id, ...params } = allParams;
  return apiClient.get<IndexResponse>(`/realtors/${id}/dashboard`, { params });
};
